import { collection, onSnapshot, addDoc, doc, setDoc, deleteDoc } from "firebase/firestore";
import { config } from "@/utils/configuration/config";
import { db } from "@/fb.js";

import EconomicData from "@/model/EconomicData";
import Configuration from "@/model/Configuration";
import Ship from "@/model/Ship";
import EconomicService from "@/services/EconomicService";

class EconomicRepo {
  private service: EconomicService;

  constructor(service: EconomicService) {
    this.service = service;
  }

  getEconomicData(ship: Ship, configuration: Configuration) {
    onSnapshot(
      collection(
        db,
        config.firebaseConfig.shipsCollectionName,
        ship.id,
        "ShipConfigurations",
        configuration.id,
        "EconomicData"
      ),
      (querySnapshot) => {
        //console.log("EconomicRepo-getEconomicData");
        const changes = querySnapshot.docChanges();

        changes.forEach(async (change) => {
          if (change.type === "added") {
            //console.log("EconomicRepo-getEconomicData added", change.doc.id);
            this.service.addedEconomicData(ship, configuration, change.doc.id, change.doc.data());
          } else if (change.type === "modified") {
            //console.log("EconomicRepo-getEconomicData modified", change.doc.id);
            this.service.modifiedEconomicData(ship, configuration, change.doc.id, change.doc.data());
          } else if (change.type === "removed") {
            //console.log("EconomicRepo-getEconomicData removed", change.doc.id);
            // this.service.removedEconimicData(ship, configuration, change.doc.id)
          }
        });
      }
    );
  }

  saveEconomicRepo(shipId: string, configuration: Configuration, economicData: EconomicData) {
    const objectToSave = this.getEconomicDataForFirebase(economicData);
    // console.log("EconomicRepo.saveEconomicRepo. Configuration =", configuration);
    // console.log("EconomicRepo.saveEconomicRepo. Ship =", shipId);
    // console.log("EconomicRepo.saveEconomicRepo. ObjectToSave =", objectToSave);

    let errors = "";
    try {
      if (configuration.economicData && configuration.economicData.id) {
        //console.log("EconomicRepo.saveEconomicRepo. Modificando", shipId, configuration.id, configuration.economicData.id);
        const ecoRef = doc(
          db,
          config.firebaseConfig.shipsCollectionName,
          shipId,
          "ShipConfigurations",
          configuration.id,
          "EconomicData",
          configuration.economicData.id
        );
        setDoc(ecoRef, objectToSave);
      } else {
        //console.log("EconomicRepo.saveEconomicRepo. Añadiendo");
        addDoc(
          collection(
            db,
            config.firebaseConfig.shipsCollectionName,
            shipId,
            "ShipConfigurations",
            configuration.id,
            "EconomicData"
          ),
          objectToSave
        );
      }
    } catch (error) {
      //console.log("EconomicRepo.saveEconomicRepo ERROR:", error);
      errors += error;
    }

    return errors;
  }

  getEconomicDataForFirebase(economicData: EconomicData) {
    const initialFuel = new Array<{}>();
    economicData.fuelEconomicDatasInitial.forEach((fuelEconomic) => {
      initialFuel.push({
        ...fuelEconomic,
      });
    });
    const modifiedFuel = new Array<{}>();
    economicData.fuelEconomicDatasModified.forEach((fuelEconomic) => {
      modifiedFuel.push({
        ...fuelEconomic,
      });
    });

    const objectToSave: any = {
      ...economicData,
    };

    delete objectToSave.id;
    objectToSave.fuelEconomicDatasInitial = initialFuel;
    objectToSave.fuelEconomicDatasModified = modifiedFuel;

    return objectToSave;
  }
}

export default EconomicRepo;
